module.exports = __webpack_public_path__ + "img/configureGrey.70668412.svg";